export default "__VITE_ASSET__54c2f0c9__"